import React from 'react';
import { Typography } from '../Typography';

interface IDiscountLabelProps {
	label: string;
}

export const DiscountLabel = ({ label }: IDiscountLabelProps) => (
	<div data-cy={'Discount label'} className="text-right leading-none">
		<Typography
			variant="header"
			color="white"
			size="xs"
			className="mt-1 bg-secondary px-1 py-[1px] box-decoration-clone">
			{label}
		</Typography>
	</div>
);
